const queryString = require('query-string');

// let hash_ = "inhouse0403-coreference_resolution-batch1"
// let hash_ = "inhouse0403-conversational_qa-batch1"
// let hash_ = "inhouse0403-sentiment_analysis-batch1"
// let hash_ = "release0610-coreference_resolution-batch3"
// let hash_ = "inhouse0403-dialogue_contradiction_detection-batch1"
let hash_ = "release0908-sentiment_analysis-batch1"

let queryDict = queryString.parse(window.location.search);  // parameters in GET (after ? in url)
console.log("[queryString] window.location.search:", window.location.search)
if (!Object.keys(queryDict).includes('hash')) {
    console.log("no >hash< in query dict.")
    queryDict = {
        host:"",
        modification_type: "derivation",
        instruction_key: "derivation" +
            "",
        assignmentId: 3,
        workerId:"2000",
        hitId:1,
        hash: hash_,
        entityTest: "continue", // "continue"
        bonus: 0,
        bonusMomentum: 0,
        minTrap: 0.75,
        minTime: 0,
        maxHitsNum: 30,  // max hits allowed per user
        completionCode: "empty",
        SESSION_ID: "local-test"
    };
    console.warn('Wrong number of arguments in query string QueryDict: ' + JSON.stringify(queryDict));
} else {
    console.log(">hash< detected in query dict.")
}

console.log("queryDict:", queryDict)
export { queryDict };